import { useState, useEffect } from 'react';

export const useVisibilityHandler = (ref, onVisibilityChange) => {
    const [currentState, setCurrentState] = useState();
    useEffect(
        () => {
            if (!ref) {
                return;
            }
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.boundingClientRect.top < 0 && currentState != 'ABOVE_VIEWPORT_TOP') {
                        setCurrentState('ABOVE_VIEWPORT_TOP');
                        onVisibilityChange('ABOVE_VIEWPORT_TOP');
                    } else if (entry.boundingClientRect.top >= 0 && currentState != 'BELOW_VIEWPORT_TOP') {
                        setCurrentState('BELOW_VIEWPORT_TOP');
                        onVisibilityChange('BELOW_VIEWPORT_TOP');
                    }
                },
                {
                    threshold: [...new Array(100)].map((_, idx) => idx / 100),
                }
            );

            observer.observe(ref);

            return () => {
                observer.unobserve(ref);
            };
        },
        [ref]
    );
};
